import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, mergeMap } from 'rxjs/operators';
import { RequestService } from 'src/app/shared/services/request.service';

import * as RequestsOverviewSlideActions from '../requests-overview-slide.actions';

@Injectable()
export class RequestsOverviewSlideEffects {
  private readonly actions$ = inject(Actions);
  private readonly requestsService = inject(RequestService);

  requestMakeMatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequestsOverviewSlideActions.requestMakeMatch),
      mergeMap((action) =>
        this.requestsService
          .makeMatch(action.requestId)
          .pipe(
            map((response) => RequestsOverviewSlideActions.requestMakeMatchSuccess({ response })),
          ),
      ),
    ),
  );
}
